import React from "react";
import { Accordion } from "../../../components/elements/forms/Accordion";
import { ImArrowUpRight2 } from "react-icons/im";
import FaqModal from "./FaqModal";
import { Link } from "react-router-dom";

const FaqClients = () => {
  const [show, showSet] = React.useState<boolean>(false);
  return (
    <div className="accordion font-abel mb-20">
      <Accordion title="1. How is your fee calculated?">
        <div className="inline-block w-full">
          <span className="inline-block">
            <span>Our recruitment fee is</span>
            <span className="inline-block mx-1 text-primary">
              <Link to="/services/packages" className="flex items-center">
                %
                <span className="ml-1">
                  <ImArrowUpRight2 size={15} />
                </span>
              </Link>
            </span>
          </span>
          <span className="">
            of the candidate's guaranteed first-year compensation, which
            includes base salary, allowances, sign-on bonuses, and any other
            guaranteed remuneration listed in the offer letter.
          </span>
        </div>
      </Accordion>

      <Accordion title="2. When is the fee due?">
        The fee is invoiced upon the candidate's acceptance of your offer and is
        payable within 5 business days.
      </Accordion>
      <Accordion title="3. What does 'guaranteed compensation' mean?">
        This covers all fixed, guaranteed elements of the package base salary,
        sign-on bonuses, allowances, and other contractual commitments. It does
        not include discretionary bonuses, stock options, or variable incentives
        unless guaranteed in writing.
      </Accordion>
      <Accordion title="4. What if the candidate gets a raise, promotion, or adjustment?">
        If the candidate's guaranteed compensation is increased within 12 months
        of their start date, our fee will be recalculated on the new adjusted
        package.
        <ul
          typeof="square"
          className="privacy-list text-[16px] md:text-[16px] text-[#000000]"
        >
          <li className="my-2">
            This ensures fairness: you only pay in proportion to the true value
            of your hire.
          </li>
          <li className="my-2">
            It protects your replacement guarantee: disclosure and adjustment
            are required to keep the guarantee valid.
          </li>
          <li className="my-2">
            It keeps us aligned with market value: if you later recognize the
            package was below market, our fee adjusts accordingly.
          </li>
        </ul>
      </Accordion>
      <Accordion title="5. Why do you charge an additional fee if a candidate gets a raise or promotion within the first year?">
        Our fees are tied to the candidate's guaranteed first-year compensation.
        <br />
        <p>
          If you later adjust the package with a raise, bonus, or promotion
          within the first 12 months, it means the original package was below
          the candidate's true market value.
        </p>
        <p>
          Since our fee is performance-based and reflects the actual value of
          the hire, we adjust our invoice to match the updated package.
        </p>
      </Accordion>
      <Accordion title="6. How does 25th & Staffing source candidates for client roles?">
        We use our proprietary AI Recruiter platform to pre-screen, shortlist,
        and match candidates efficiently. The same system can be customized for
        your organization to help you hire faster and integrate directly with
        your job boards. Learn more or request an in-house setup through our{" "}
        <a href="#" className="text-primary">
          AI Recruiter page.
        </a>
      </Accordion>
      <Accordion title="7. What if we don't disclose a raise or compensation adjustment?">
        Failure to disclose constitutes a breach of agreement and voids your
        replacement guarantee. Transparency ensures smooth partnership and
        avoids disputes later.
      </Accordion>
      <Accordion title="8. Do you offer a replacement guarantee?">
        Yes, if the candidate resigns, withdraws, or is terminated for
        performance reasons within 30, 60, 90, or 180 days (depending on your
        selected service tier), we'll provide a one-time replacement at no
        additional search fee, provided:
        <ul
          typeof="square"
          className="privacy-list text-[16px] md:text-[16px] text-[#000000]"
        >
          <li className="my-2">
            The original invoice was fully settled within 5 business days, and
          </li>
          <li className="my-2">
            Any compensation changes were disclosed in good faith.
          </li>
        </ul>
        <p>
          Note: The replacement guarantee and true-up clause operate
          independently.
        </p>
      </Accordion>
      <Accordion title="9. What if the role or job description changes after placement?">
        <b className="font-[900]">Significant</b> changes (title, scope, or
        location) beyond the agreed search brief may affect the guarantee. In
        such cases, we'll work with you on a new search mandate.
      </Accordion>
      <Accordion title="10. What if we hire a candidate outside of your introduction?">
        Our introductions are confidential. If you hire a candidate we presented
        within 12-24 months of introduction depending on the selected package,
        the standard fee applies.
      </Accordion>
      <Accordion title="11. Why is your model based on guaranteed compensation rather than a flat fee?">
        We use guaranteed compensation to align our success with yours.It
        ensures we place the right candidate for long term impact, not just fill
        a role. Quality,fit,and retention come first,when you succeed,we
        succeed.
      </Accordion>
      <Accordion title="12. What if we disagree on compensation being 'market value'?">
        <p className="pb-2">
          Market value isn't subjective it's evidenced by your own later
          adjustments (raises, promotions, retention bonuses). If you later
          increase compensation within 12 months, it is assumed the original
          package was under market, and our fee is adjusted accordingly.
        </p>
        <p className="pb-2">
          For example, Korn Ferry's 2025 Form 10-K filing (page 66) publicly
          states:
        </p>
        <p className="pb-2">
          "In addition to the search retainer, an uptick fee is billed when the
          actual compensation awarded by the client for a placement is higher
          than the estimated compensation."
        </p>
        <p>
          <a
            className="font-bold text-primary flex items-center"
            href="https://ir.kornferry.com/sec-filings/all-sec-filings/content/0001628280-25-033260/0001628280-25-033260.pdf?utm_source=chatgpt.com"
            target="_blank"
            rel="noreferrer"
          >
            — Korn Ferry 2025 Form 10-K, ir.kornferry.com{" "}
            <span className="ml-1">
              <ImArrowUpRight2 size={20} />
            </span>
          </a>
        </p>
        <p>
          This practice known in the industry as a true-up clause ensures
          fairness when the candidate's guaranteed compensation increases
          through a raise, promotion, or market correction within the first
          year. It is not arbitrary billing but a reflection of the candidate's
          actual market value and the final terms of employment.
        </p>
      </Accordion>
      <Accordion title="13. How does your model compare to contingency recruiting?">
        We operate under a retained executive search model, not contingency
        recruiting. The distinction is important because the terms, guarantees,
        and commitment levels are very different.
      </Accordion>

      <div className="flex items-center pb-3 mt-5">
        <p className="text-[15px] md:text-[20px] flex items-center">
          Contingency or Retainer? Find out which hiring model gives you better
          results.
          <span
            className="flex items-center ml-2 cursor-pointer text-primary"
            onClick={() => showSet(true)}
          >
            <span className="text-[15px] md:text-[20px] mr-2">
              {" "}
              View Comparison
            </span>
            <span>
              <ImArrowUpRight2 size={20} />
            </span>
          </span>
        </p>
      </div>
      <FaqModal
        visible={show}
        onHandleOk={() => showSet(false)}
        onCancel={() => showSet(false)}
      />
    </div>
  );
};

export default FaqClients;
